document.addEventListener('DOMContentLoaded', function() {
  const images = document.querySelectorAll('img');
  images.forEach(img => {
    // Prevent right-click context menu (desktop and touch long-press)
    img.addEventListener('contextmenu', (e) => e.preventDefault());
    // Prevent drag-and-drop (desktop)
    img.addEventListener('dragstart', (e) => e.preventDefault());
    // Prevent mouse selection (desktop)
    img.addEventListener('mousedown', (e) => e.preventDefault());
    // Prevent touch selection and long-press (mobile/tablet)
    img.addEventListener('touchstart', (e) => e.preventDefault());
    img.addEventListener('touchmove', (e) => e.preventDefault());
  });

  // Optional: Attempt to deter PrintScreen and dev tools (desktop)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'PrintScreen' || (e.ctrlKey && (e.key === 'I' || e.key === 'i'))) {
      e.preventDefault(); // Limited effect, acts as deterrent only
    }
  });
});